import React, { useState, useEffect } from "react";
import { FormGroup, ControlLabel, FormControl, Button } from "react-bootstrap";
import * as API from '../../../api/billing';

const BillRefund = ({ row, handleCloseRefundModal }) => {
    const [selectedPatient, setSelectedPatient] = useState(null);
    const [refundAmount, setRefundAmount] = useState("");
    const [billNo, setBillNo] = useState("");
    const [btnClicked, setBtnClicked] = useState(false);

    const safeNumber = (val) => {
        const num = Number(val);
        return isNaN(num) ? 0 : num;
    };

    const handleSaveRefund = async () => {
        setBtnClicked(true);
        try {
            const payload = {
                id: row?._id || "",
                refundAmount: safeNumber(refundAmount)
            };
            let resp = await API.billRefund(payload);
            if (resp?.data?.status === "Success" && resp?.data?.statusCode) {
                handleUpdateBill()
            }
        } catch (error) {
            // Optionally handle error (e.g., show notification)
            console.error("Error processing refund:", error);
            setBtnClicked(false)
        }
    };

    const handleUpdateBill = async () => {

        try {
            const refunded = safeNumber(refundAmount);
            const totalAmount = safeNumber(row?.totalAmount);
            const totalPaidAmount = safeNumber(row?.totalPaidAmount);
            const totalDiscount = safeNumber(row?.totalDiscountAmount);
            const netPayble = totalPaidAmount - refunded
            const totalRefundedAmount = row?.refundAmount ? safeNumber(row?.refundAmount) + safeNumber(refundAmount) : safeNumber(refundAmount)

            const payload = {
                id: row?._id,
                patientId: selectedPatient._id,
                totalAmount: totalAmount,
                totalPaidAmount: netPayble,
                totalDiscountAmount: totalDiscount,
                totalRemainingAmount: totalAmount - (netPayble + totalRefundedAmount + totalDiscount),
                refundAmount: totalRefundedAmount,
                services: JSON.stringify(row?.services),
            };
            let resp = await API.updateBill(payload);

            if (resp?.data?.status === "Success" && resp?.data?.statusCode) {
                handleCloseRefundModal("updateBill");
            }

        } catch (error) {
            console.error("Error in handleSubmit:", error);
        } finally {
            setBtnClicked(false);
        }
    }


    useEffect(() => {
        if (row) {
            setBillNo(row?.billNumber);
            const patientDetail = {
                firstName: row?.patientData?.firstName,
                lastName: row?.patientData?.lastName,
                patientClinicId: row?.patientData?.patientClinicId
            };
            setSelectedPatient(patientDetail);
        }
    }, [row]);

    // Helper to display amounts with ₹ only if > 0
    const formatAmount = (amount) => {
        if (!amount || amount === "0" || amount === 0) return "";
        return `₹${amount}`;
    };

    const formatMaxRefundedAmount = () => {
        const total = Number(row?.totalAmount) || 0;
        const refunded = Number(row?.refundAmount) || 0;
        return Math.max(0, total - refunded);
    };

    // Validation state
    const [error, setError] = useState("");

    // Validate refundAmount before saving
    const validateAndSaveRefund = () => {
        const totalAmount = safeNumber(row?.totalAmount);  // Total amount from the bill
        const paidAmount = safeNumber(row?.totalPaidAmount);  // Total paid amount
        const entered = safeNumber(refundAmount);  // Refund amount entered by the user

        if (entered <= 0) {
            setError("Please enter a valid amount greater than 0.");
            return;
        }
        if (entered > paidAmount) {
            setError("Refund amount cannot be greater than paid amount.");
            return;
        }
        if (entered > totalAmount) {
            setError("Refund amount cannot be greater than total amount.");
            return;
        }
        setError("");
        handleSaveRefund();
    };

    return (
        <div style={{ fontFamily: "Arial", padding: 20 }}>

            {/* Patient Details Strip */}
            {selectedPatient && (
                <div style={{
                    display: "flex",
                    justifyContent: "space-between",
                    border: "1px solid #ddd",
                    padding: "15px 20px",
                    borderRadius: 8,
                    marginBottom: 20,
                    backgroundColor: "#f9f9f9",
                    fontWeight: "bold"
                }}>
                    <div>Bill No: {billNo}</div>
                    <div>Patient Name: {selectedPatient.firstName} {selectedPatient.lastName}</div>
                    <div>Patient ID: {selectedPatient.patientClinicId}</div>
                </div>
            )}

            {/* Amount Summary Box */}
            <div style={{
                display: "flex",
                justifyContent: "space-between",
                border: "1px solid #ddd",
                padding: "15px 20px",
                borderRadius: 8,
                marginBottom: 20,
                backgroundColor: "#eef2f7",
                fontWeight: "bold"
            }}>
                <div>Total Amount: {formatAmount(row?.totalAmount)}</div>
                <div>Total Paid: {formatAmount(row?.totalPaidAmount)}</div>
                <div>Total Discount: {formatAmount(row?.totalDiscountAmount)}</div>
                <div style={{ color: row?.totalRemainingAmount > 0 ? "red" : "black" }}>
                    Remaining: {formatAmount(row?.totalRemainingAmount)}
                </div>
                {row?.refundAmount &&
                    <div >
                        Already Refunded: {formatAmount(row?.refundAmount)}
                    </div>
                }

            </div>

            {/* Refund Details Box */}
            <div style={{
                border: "1px solid #ddd",
                padding: "15px 20px",
                borderRadius: 8,
                display: "flex",
                alignItems: "center",
                gap: "15px"
            }}>
                <FormGroup controlId="refundAmount" style={{ flex: 1, marginBottom: 0 }}>
                    <ControlLabel>Enter Refund Amount</ControlLabel>
                    <FormControl
                        type="number"
                        value={refundAmount}
                        placeholder="Enter refund amount"
                        onChange={(e) => {
                            setRefundAmount(e.target.value);
                            setError(""); // Clear error on change
                        }}
                    />
                    {error && (
                        <div style={{ color: "red", marginTop: 5, fontSize: 13 }}>
                            {error}
                        </div>
                    )}
                </FormGroup>

                <Button bsStyle="danger" onClick={validateAndSaveRefund} style={{ marginTop: 18 }} disabled={btnClicked}>
                    <span>
                        Refund{" "}
                        {btnClicked && <i className="fa fa-spinner fa-spin"></i>}
                    </span>
                </Button>
            </div>
        </div>
    );
};

export default BillRefund;
